import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import AuthMedia from "../components/AuthMedia";
import { Images, PlayCircle } from "lucide-react";

const AlbumFoto = () => {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/memories").then((res) => {
      const gallery = [];
      for (const m of res.data) {
        for (const media of m.media || []) {
          if (media.kind === "image") {
            gallery.push({ display: media, memory: m, isVideo: false });
          } else if (media.kind === "video" && media.poster) {
            gallery.push({ display: { ...media, storage_path: media.poster, kind: "image" }, memory: m, isVideo: true });
          }
        }
      }
      setItems(gallery);
    }).catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 py-10 fade-in">
        <div className="mb-8">
          <h1 className="font-serif text-4xl tracking-tight">Album Foto</h1>
          <p className="text-muted-foreground mt-2">Tutte le immagini dei tuoi ricordi, raccolte in un unico luogo.</p>
        </div>

        {items === null ? (
          <p className="text-muted-foreground">Caricamento…</p>
        ) : items.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-3xl border border-border" data-testid="album-empty">
            <div className="w-16 h-16 rounded-2xl bg-[#EAF2ED] flex items-center justify-center mx-auto mb-6">
              <Images className="w-8 h-8 text-[#81B29A]" />
            </div>
            <h3 className="font-serif text-2xl mb-2">Nessuna foto ancora</h3>
            <p className="text-muted-foreground max-w-sm mx-auto">Aggiungi foto o video ai tuoi ricordi e appariranno qui.</p>
          </div>
        ) : (
          <div className="columns-2 sm:columns-3 lg:columns-4 gap-4 [column-fill:_balance]" data-testid="album-grid">
            {items.map((it, i) => (
              <button
                key={i}
                onClick={() => navigate(`/ricordi/${it.memory.id}`)}
                className="mb-4 block w-full break-inside-avoid rounded-2xl overflow-hidden border border-border bg-white group relative"
                data-testid={`album-item-${i}`}
              >
                <AuthMedia item={it.display} className="w-full object-cover group-hover:opacity-95 transition-opacity" />
                {it.isVideo && (
                  <span className="absolute top-2 right-2 bg-black/60 text-white rounded-full p-1">
                    <PlayCircle className="w-4 h-4" />
                  </span>
                )}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <p className="text-white text-sm font-serif truncate">{it.memory.title}</p>
                </div>
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default AlbumFoto;
